module.exports = __webpack_public_path__ + "img/gzh-ewm.af47d7b2.jpg";